import { takeLatest, put, call } from 'redux-saga/effects';

import { RUN_DEPENDENCIES, DEPENDENCY_CONFIG } from './dependencyConfigModule';
import { loadingAction } from '../../loader/loaderModule';
import emptyFunc from '../../utils/emptyFunc';

export function* runDependencies({ stepName }) {
    
    yield put(loadingAction({ isLoading: true }));

    
    const dependencies = DEPENDENCY_CONFIG[stepName] || emptyFunc;
    
    yield call(dependencies);

    
    yield put(loadingAction({ isLoading: false }));
}

export function* dependencyWatcherSaga() {
    yield takeLatest(RUN_DEPENDENCIES, runDependencies);
}
